import axios from "../../config/axiosConfig";
import {
  DEBIT_CREDIT_NOTE_REPORT_REQUEST,
  DEBIT_CREDIT_NOTE_REPORT_SUCCESS,
  DEBIT_CREDIT_NOTE_REPORT_FAILURE,
  GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST,
  GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
  GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE,
  GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST,
  GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
  GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE,
  GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST,
  GET_ITEMS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
  GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE,
  GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST,
  GET_BROKERS_OF_DEBIT_CREDIT_NOTE_SUCCESS,
  GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE
} from "../types/debit-credit-note-report-types";

export const getAllAccountOfDebitCreditNote = (commonMaster, registerType) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get(`/${registerType === 'credit' ? 'credit-note' : 'debit-note'}/${registerType === 'credit' ? 'getAllAccountOfCreditNote' : 'getAllAccountOfDebitNote'}`, { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllDebitCreditAccountOfDebitCreditNote = (commonMaster, registerType) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get(`/${registerType === 'credit' ? 'credit-note' : 'debit-note'}/${registerType === 'credit' ? 'getAllDebitAccountOfCreditNote' : 'getAllCreditAccountOfDebitNote'}`, { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_DEBIT_CREDIT_ACCOUNTS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllItemOfDebitCreditNote = (commonMaster, registerType) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get(`/${registerType === 'credit' ? 'credit-note' : 'debit-note'}/${registerType === 'credit' ? 'getAllItemsOfCreditNote' : 'getAllItemsOfDebitNote'}`, { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_ITEMS_OF_DEBIT_CREDIT_NOTE_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_ITEMS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getAllBrokerOfDebitCreditNote = (commonMaster, registerType) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get(`/${registerType === 'credit' ? 'credit-note' : 'debit-note'}/${registerType === 'credit' ? 'getAllBrokersOfCreditNote' : 'getAllBrokersOfDebitNote'}`, { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BROKERS_OF_DEBIT_CREDIT_NOTE_SUCCESS, payload: response.data });
          return response.data;
        }
        return null;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
        return null;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: GET_BROKERS_OF_DEBIT_CREDIT_NOTE_REQUEST_FAILURE, error: error.message });
      return null;
    }
  };
};

export const getDebitCreditNoteReport = (params, registerType) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DEBIT_CREDIT_NOTE_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      console.log('params',params);
      
      const defaultParams2 = {
        filterType: params?.filterType || '',
        fromDate: params?.fromDate || '', 
        toDate: params?.toDate || '', 
        ...params
      };

      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/${registerType === 'credit' ? 'credit-note' : 'debit-note'}/getReport?${queryString}`;
      console.log('Complete API Request URL: ', fullUrl);

      axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        if (response.data) {
          dispatch({ type: DEBIT_CREDIT_NOTE_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: DEBIT_CREDIT_NOTE_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: DEBIT_CREDIT_NOTE_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearDebitCreditNoteReport = () => {
  return async (dispatch) => {
    dispatch({ type: DEBIT_CREDIT_NOTE_REPORT_SUCCESS, payload: {} });
  }
}
